<ng-container *ngIf="loading == false && data && data.length != 0; else elseBlockTracking">
    <div class="al-grid grid-2-inner" style="margin-bottom: 0">
        <h2 class="g-card-title">Activity</h2>

        <table *ngIf="data && data.length != 0" style="height: 50px">
            <tr>
                <td><span class="g-text-secondary">Ordered</span></td>
                <td><span class="g-text-secondary">Received</span></td>
            </tr>
        </table>
    </div>

    <div class="al-grid grid-2-inner" *ngFor="let t of data">
        <span class="g-text-title" style="padding-top: 5px">
            <i
                class="far"
                [ngClass]="{
                    'fa-circle':
                        (t.orderedDate == null && t.receivedDate) ||
                        (t.receivedDate == null && (t.alert == null || t.alert == false)),
                    'fa-check-circle':
                        t.orderedDate && t.receivedDate && (t.alert == null || t.alert == false),
                    'fa-exclamation-circle': t.alert != null && t.alert == true
                }"
            ></i>
            &nbsp;
            {{ t.trackingType }}
        </span>

        <table cellpadding="0" cellspacing="0">
            <tr>
                <td style="min-width: 100px">
                    <span class="g-text-content" *ngIf="t.orderedDate">
                        {{ t.orderedDate | date : 'MM/dd/yyyy' : 'UTC' }}
                    </span>
                    <span *ngIf="!t.orderedDate" style="width: 85px">&nbsp;</span>
                </td>
                <td style="min-width: 100px">
                    <span class="g-text-content" *ngIf="t.receivedDate">
                        {{ t.receivedDate | date : 'MM/dd/yyyy' : 'UTC' }}
                    </span>
                    <span *ngIf="!t.receivedDate" style="width: 85px">&nbsp;</span>
                </td>
            </tr>
        </table>
    </div>
</ng-container>

<ng-template #elseBlockTracking>
    <h2 class="g-card-title">Activity</h2>

    <div *ngIf="loading; else notLoadingNoData">
        <spin-loader></spin-loader>
    </div>

    <ng-template #notLoadingNoData>
        <no-data-screen [noDataType]="noDataSelection"></no-data-screen>
    </ng-template>
</ng-template>
